import { UADEnums } from "./enums";

export function toDollarAmount(amt) {
  var num = (typeof amt === 'string') ? Number(amt) : amt;
  var value = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    negative: 'parenthesis',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
    currencySign: 'accounting'
    }
  ).format(num);

  return value;
}

export function toDollarAndCentsAmount(amt) {
  var num = (typeof amt === 'string') ? Number(amt) : amt;
  const value = new Intl.NumberFormat('en-US', 
    { style: 'currency', 
      currency: 'USD'
     }
    ).format(num);

  return value;
}

export function dollarToNumber(amt) {
  if (typeof amt !== 'string') return 0;
  if (isEmpty(amt)) return 0;
  let value = 0;
  amt = amt.replace('$', '');
  amt = amt.replace(/,/g, '');
  if (amt.charAt(0) === "(") {
    amt = amt.substring(1, amt.length-1);
    value = -Number(amt);
  } else
    value = Number(amt);

  return value;
}

export function formatFullName(element) {
  //console.log('element: ',typeof element, element);
  if (element === undefined) return '';
  const fn = getAttrValue(element, "_FirstName");
  const mn = getAttrValue(element, "_MiddleName");
  const ln = getAttrValue(element, "_LastName");
  var gen = getAttrValue(element, "_NameSuffix");
  //console.log(fn,mn,ln, gen);
  var name = addWithSpace(fn, mn);
  name = addWithSpace(name, ln);
  name = addWithSpace(name, gen);
  return name;
}

export function formatFullAddress(element) {
  //console.log('element: ',typeof element, element);
  if (element === undefined) return '';
  var a = getAttrValue(element, "_StreetAddress");
  const c = getAttrValue(element, "_City");
  const s = getAttrValue(element, "_State");
  const p = getAttrValue(element, "_PostalCode");
  //console.log("addr: ", a1, a2, c, s, p);
  a = addWithComma(a, c);
  a = addWithComma(a, s);
  a = addWithSpace(a, p);
  return a;
}

export function formatSSN(element) {
  //console.log('element: ',element);
  if (element === undefined) return '';
  var ssnin = getAttrValue(element, "_SSN");
  //console.log("ssnin: ", ssnin);
  if (ssnin === undefined) return '';
  var ssn = ssnin.substring(0,3) + '-' + ssnin.substring(3,5) + '-' + ssnin.substring(5);
  //console.log("ssn: ", ssn);
  return ssn;
}

export function addWithSpace(s1, s2) {
  //console.log(s1, s2);
  if (isEmpty(s2)) return s1;
  if (isEmpty(s1)) return s2;
  var s = s1 + ' ' + s2;
  return s;
}

export function addWithSpacer(s1, s2, spacer) {
  //console.log(s1, s2);
  if (!spacer) spacer = " | ";
  var s;
  if (isEmpty(s2)) return s1;
  if (isEmpty(s1)) return s2;
  s = s1 + spacer + s2;
  return s;
}

export function addWithComma(s1, s2) {
  //console.log(s1, s2, typeof s2, s2.length);
  var s;
  if (isEmpty(s2)) return s1;
  if (isEmpty(s1)) return s2;
  s = s1 + ', ' + s2;
  return s;
}

export function addWithNewline(s1, s2) {
  //console.log(s1, s2, typeof s2, s2.length);
  var s;
  if (isEmpty(s2)) return s1;
  if (isEmpty(s1)) return s2;
  s = s1 + '\n' + s2;
  return s;
}


export function isEmpty(value) {
  //console.log("isEmpty: ", typeof value, value);
  if (value === undefined) { return true; }
  if (value === null) { return true; }

  if (typeof value !== 'object') {
    // boolean, number, string, function, etc.
    if (typeof value === 'string') {
      var result = (value === '') ? true : false;
      return result;
    }
    return false;
  }
    
  //console.log(value);
  try {
    for (const prop of value) {
      if (Object.hasOwn(value, prop)) {
        return false;
      }
    }
  } catch (err) {
    console.log("isEmpty", err);
    console.log(value);
  }
  return true;
}

export function getTagValue(element, tag) {
	let value = '';
  let el = element[tag]
  //console.log("el: ", el);
  if (el === undefined) return '';
  if (el.length !== 0) value = el._text;
  if (value === undefined) value = el._number;
  //console.log("val: ", value);
  if (value === undefined) return '';
  return value;
}

export function getAttrValue(element, tag) {
	let attr = element._attributes;
  //console.log("attr: ", attr);
  let value = attr[tag];
  //console.log("attr value: ", value);
  return value;
}

export function getTagAttrValue(element, tag, attr) {
  let ele = element[tag];
  //console.log("ele: ", ele);
  if (!ele) return '';
	let atr = ele._attributes;
  //console.log("atr: ", atr);
  if (!atr) return '';
  let value = atr[attr];
  if (!ele) return '';
  //console.log("TAGattr value: ", value);
  return value;
}

export function formatDateMY(d) {
	if (!d) return '';
	var date = d;
	var fmt = '';
	var parts = date.split('-');
	//console.log(parts);
	if (parts.length === 2) {
		fmt = parts[1] + '/';
		fmt = fmt + parts[0].slice(-2);
	} else if (parts.length === 3) {
		fmt = parts[1] + '/';
		fmt = fmt + parts[0].slice(-2);
	}
	return fmt;
}

export function formatDateMDY(d) {
  //console.log("formatDate: ", d);
	if (isEmpty(d)) return '';
	var date = d;
  var ix = date.indexOf('T');
  if (ix > 0) date = date.substring(0, ix);
	var fmt = '';
	var parts = date.split('-');
	//console.log(parts);
	if (parts.length === 2) {
		fmt = parts[1] + '/';
		fmt = fmt + parts[0].slice(-2);
	} else if (parts.length === 3) {
		fmt = parts[1] + '/';
		fmt = fmt + parts[2] + '/';
		fmt = fmt + parts[0].slice(-2);
	}
	//console.log(fmt);

	return fmt;
}

export function formatDate(d) {
  //console.log("formatDate: ", d);
	if (isEmpty(d)) return '';
	var date = d;
  var ix = date.indexOf('T');
  if (ix > 0) date = date.substring(0, ix);
	var fmt = '';
	var parts = date.split('-');
	//console.log(parts);
	if (parts.length === 2) {
		fmt = parts[1] + '/';
	} else if (parts.length === 3) {
		fmt = parts[1] + '/';
		fmt = fmt + parts[2] + '/';
		fmt = fmt + parts[0].slice(-2);
	}
	//console.log(fmt);

	return fmt;
}

export function formatPhone(number) {
	if (number === '') return '';
  if (isNaN(number[0])) return number;
	if (number.length !== 10) return number;
	var phone = number.substring(0,3) + '-' + number.substring(3,6) + '-' + number.substring(6);
	//console.log( phone);

	return phone;
}

export function trim(s, l) {
  if (!s) return '';
  if (s.length <= l) return s;
  return s.substring(0, l);
}

export function getEleArray(element, tag) {
  //console.log("EleArray: ", typeof element, element.length, element);
  let e = element[tag];
  if (e === undefined) return null;
  //console.log("e: ", typeof e, e.length, e);
  let a = [];
  if (e.length === undefined) {
    a.push(e);
  } else {
    e.forEach((e) => {a.push(e)});
  };

  //console.log("array: ", typeof a, a.length, a);
  return a;
}

export function descriptionOrOther(desc, other) {
  if (isEmpty(desc)) return "";
  if (desc === "Other") return other;
  return toEnumText(desc);
}

export function isLaterThan(a, b) {

  return false;
}

export function toEnumText(uadEnum)
{
		if (!uadEnum) return "";
		try { 
			var et = UADEnums[uadEnum];
      if (!et) {
        et = expandEnum(uadEnum);
        console.log("Expanding Enum: ", uadEnum, et)
      }
			return et;
		}
		catch (ex) { 
			var ee = expandEnum(uadEnum);
      console.log("expand: ", uadEnum, ee, ex)
			return ee;
		}
}

export function expandEnum(value) {
    if(!value) return value;
    // if the value already contains space(s), assume we don't need to do anything
    if (value.includes(" ")) return value;
    let expandedValue = '';

    for (let i = 0; i < value.length; i++) {
        if (i > 0) {
            const prevChar = value[i - 1];
            //const nextChar = (i + 1) < stringValue.length ? stringValue[i + 1] : '\0';
            const currentChar = value[i];

            if (isUpperCase(currentChar) &&
                prevChar !== '\n' &&
                prevChar !== ' ' &&
                (!isUpperCase(prevChar) || prevChar === 'A' || prevChar === 'I') && 
                !isNonAlpha(prevChar)) {
                  expandedValue += ' ';
              }
        }
        expandedValue += value[i];
    }

    return expandedValue;
}

export function isUpperCase(char) {
    return char === char.toUpperCase() && char !== char.toLowerCase();
}

export function isNonAlpha(char) {
    return !/[a-zA-Z]/.test(char);
}

export function yesNo(value) {
  if (value === null) return undefined;
  return value ? "Yes" : "No";
}

export function yesNoIf(value, doIf) {
  if (doIf !== undefined && doIf === false) return "";
  return value ? "Yes" : "No";
}

export function yesNone(value) {
  if (value === null) return null;
  return value ? "Yes" : "None";
}

export function yesDashes(value) {
  if (value === null) return "";
  return value ? "Yes" : "--";
}

export function yesNoDashes(value) {
  if (value === true) return "Yes";
  if (value === false) return "No";
  return "--";
}

export function yesUnknown(value) {
  if (value === null) return "Unknown";
  return value ? "Yes" : "No";
}

export function toTF(value) {
  if (value === null) return null;
  return value ? "true" : "false";
}

export function toChecked(value) {
  return value ? "X" : "";
}

export function rKey() {
    var length = 10;
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()';
    let result = '';
    for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * characters.length);
        result += characters[randomIndex];
    }
    //console.log("rKey: ", result);
    return result;
}

export function toPercent(value) {
  return value + "%";
}

export function toDollarString(value) {
  return "$" + value;
}

export function amountOrEmpty(amount, replacement) {
  try {
    if (!replacement) replacement = "";
    if (!amount) return replacement;
    if (!amount.HasValue()) return replacement;
    return amount.ToDollarAmount(replacement);
  } catch (err) {
    console.log("amountOrEmpty", err);
    console.log(amount);
  }
}

export function compEmpty(comp) {
  if (!comp) return true;

  return false;
}

export function compListEmpty(list) {

  for (let i = 2; i < list.length; ++i) {
    if (!compEmpty(list[i])) return false;
  }

  return true;
}

export function compListAllEmpty(list) {

  for (let i = 1; i < list.length; ++i) {
    if (!compEmpty(list[i])) return false;
  }

  return true;
}

export function sleep(time) {
  return new Promise((resolve) => setTimeout(resolve, time));
}

export function makeQuerablePromise(promise) {
    // Don't modify any promise that has been already modified.
    if (promise.isFulfilled) return promise;

    // Set initial state
    var isPending = true;
    var isRejected = false;
    var isFulfilled = false;

    // Observe the promise, saving the fulfillment in a closure scope.
    var result = promise.then(
        function(v) {
            isFulfilled = true;
            isPending = false;
            return v; 
        }, 
        function(e) {
            isRejected = true;
            isPending = false;
            throw e; 
        }
    );

    result.isFulfilled = function() { return isFulfilled; };
    result.isPending = function() { return isPending; };
    result.isRejected = function() { return isRejected; };
    return result;
}